export const PostUiIcon = {
  close: 'iconfont-be26016c5f9243bf898256e03863f8b4',
  search: 'iconfont-40f200c190eb446aa02f5c674c3d0000',
  arrowRight: 'iconfont-55d117ea0e524c6f960380476ddbb7d4'
}
